export default __webpack_public_path__ + "86131889c246aacd5ed649e1a04950e8.svg";